function wowo($) {
  setTimeout(function () {
    jQuery("html").addClass("show-c");
    var wTop = jQuery(window).scrollTop(),
      wHeight = jQuery(window).height(),
      wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
      var me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.height(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");

        setTimeout(function () {
          //me.removeClass("animated wowo");
        }, 1500);
      }
    });
  }, 100);
}

function swiper() {
  if ($("#swiper1").length) {
    var swiper1 = new Swiper("#swiper1", {
      loop: true,
      loopedSlides: 3,
      loopAdditionalSlides: 0,
      speed: 500,
      slidesPerView: 1,
      loopFillGroupWithBlank: false,
      autoplay: true,
    });
  }
    if ($("#swiper3").length) {
    var swiper1 = new Swiper("#swiper3", {
      loop: true,
      loopedSlides: 3,
      loopAdditionalSlides: 0,
      speed: 500,
      slidesPerView: "1.5",
      loopFillGroupWithBlank: false,
            breakpoints: {
        1680: {
          slidesPerView: "6",
        },
         1440: {
          slidesPerView: "5",
        },
          1200: {
          slidesPerView: "4",
        },
        767: { slidesPerView: "3" },
       575: {
          slidesPerView: "2",
        },
      },
      // autoplay: true,
    });
  }
  if ($(".shop-lists").length) {
    var swiper1 = new Swiper("#swiper2", {
      loop: true,
      speed: 500,
      grabCursor: true,
      slidesPerView: "1",
      touchEventsTarget: "container",
      // freeMode: true,
      // autoplay: true,
      spaceBetween: 20,
      slideToClickedSlide: false,
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 15,
        sensitivity: 0.8,
        eventsTarget: "container",
      },
      simulateTouch: true,
      touchRatio: 1,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: " .shop-lists-content .swiper-button-next",
        prevEl: ".shop-lists-content .swiper-button-prev",
      },

      breakpoints: {
        1200: {
          slidesPerView: "4",
          spaceBetween: 50,
        },
        767: { slidesPerView: "3" },
        575: {
          slidesPerView: "2",
        },
      },
      on: {
        init: function () {
          let modalsContainer = document.getElementById("modals-container");
          if (!modalsContainer) {
            modalsContainer = document.createElement("div");
            modalsContainer.id = "modals-container";
            document.body.appendChild(modalsContainer);
          }

          const slides = this.slides;
          slides.forEach((slide) => {
            const modals = slide.querySelectorAll(".modal");
            modals.forEach((modal) => {
              modal.remove();
              modalsContainer.appendChild(modal);
            });
          });
        },
      },
    });
  }

}
function marquee() {
  Marquee3k.init({ selector: "marquee3k" });

  document.querySelectorAll(".marquee3k").forEach((el) => {
    el.addEventListener("mouseenter", () => {
      Marquee3k.pauseAll();
    });

    el.addEventListener("mouseleave", () => {
      Marquee3k.playAll();
    });
  });
}

function resizeWindow() {
  const $items = $(".shop-lists-content  .swiper-slide");
  let maxHeight = 0;

  $items.each((index, element) => {
    const textHeight = $(element).find(".grid-product__link").height() || 0;
    if (textHeight > maxHeight) maxHeight = textHeight;
  });

  $(".shop-lists-content ").attr("style", "--h:" + maxHeight + "px");
}
function animationIcon() {
  const element1 = document.querySelector(".text-icon-1");
  const element2 = document.querySelector(".text-icon-2");

  if (!element1 || !element2) return;

  function startAnimation() {
    element1.style.animation = "none";
    void element1.offsetWidth;
    element1.style.animation = "rotateAnimation 3s forwards";

    element2.style.animation = "none";
    void element2.offsetWidth;
    element2.style.animation = "MoveAnimation 3s forwards";
  }

  setInterval(startAnimation, 6000);
  startAnimation();
}
var $ = jQuery.noConflict();
jQuery(document).ready(function () {
  wowo();
  swiper();
  marquee();
  resizeWindow();
  animationIcon();
  jQuery(window).scroll(function () {
    wowo();
  });
  jQuery(window).resize(function () {
    // marquee()
    resizeWindow();
  });
});
